import { axios } from 'data';

import {
  PaymentCardAvsVerificationParams,
  PaymentCardCreateParams,
  PaymentCardOtpVerificationParams,
  PaymentCardPinVerificationParams,
  PaymentFrancophoneCreateParams,
  PaymentResponse,
  PaymentStatusResponse,
} from 'types/services';

const getPaymentStatus = async (trxRef: string) => {
  const response = await axios.get<PaymentStatusResponse>(`/payment/${trxRef}/status`);

  return response.data;
};

const createCardPayment = async (params: PaymentCardCreateParams) => {
  const response = await axios.post<PaymentResponse>('/payment/card-charge/create', params);

  return response.data;
};

const verifyCardPaymentAvs = async (trxRef: string, params: PaymentCardAvsVerificationParams) => {
  const response = await axios.post<PaymentResponse>(`/payment/card-charge/${trxRef}/accept-avs-data`, params);

  return response.data;
};

const verifyCardPaymentOtp = async (trxRef: string, params: PaymentCardOtpVerificationParams) => {
  const response = await axios.post<PaymentResponse>(`/payment/card-charge/${trxRef}/accept-otp-code`, params);

  return response.data;
};

const verifyCardPaymentPin = async (trxRef: string, params: PaymentCardPinVerificationParams) => {
  const response = await axios.post<PaymentResponse>(`/payment/card-charge/${trxRef}/accept-pin-code`, params);

  return response.data;
};

const createFrancophonePayment = async (params: PaymentFrancophoneCreateParams) => {
  const response = await axios.post<PaymentResponse>('/payment/francophone/create', params);

  return response.data;
};

const paymentService = {
  getPaymentStatus,
  createCardPayment,
  verifyCardPaymentAvs,
  verifyCardPaymentOtp,
  verifyCardPaymentPin,
  createFrancophonePayment,
};

export default paymentService;
